const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.company_positions/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.company_positions/LIST_COMPANY_POSITIONS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };
    case 'table.company_positions/LIST_COMPANY_POSITIONS_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    default:
      return state;
  }
}
